import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=46c6cdba&"
import script from "./FooterContent.vue?vue&type=script&lang=js&"
export * from "./FooterContent.vue?vue&type=script&lang=js&"
import style0 from "./FooterContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports